<template>
    <div>
        <div class="wrapper">
            <div class="animated fadeIn">
                <b-row>
                    <b-col cols="12" class="mb-3">
                        <b-button @click="openImportModal" class="pull-right" v-can="'leveringen aanmaken'">Importeren</b-button>
                    </b-col>
                </b-row>
                <resource-index ref="resourceIndex" header="Orders" endpoint="orders" show-route="orders.view" />
            </div>
        </div>

        <b-modal size="md" id="import-orders" ref="import-orders" title="Orders importeren" hide-footer>
            <OrdersImport @callback="reset" />
        </b-modal>

    </div>
</template>

<script>
    import ResourceIndex from '../../components/ResourceIndex';
    import OrdersImport from '@/views/orders/Import';

    export default {
        name: 'orders',
        components: {ResourceIndex, OrdersImport},
        methods: {
            reset() {
                const $resourceIndex = this.$refs.resourceIndex;
                $resourceIndex.resetFilters();
            },
            openImportModal() {
                this.$refs['import-orders'].show()
            },
            hideImportModal() {
                this.$refs['import-orders'].hide();
            },
        },
    }
</script>
